import { useEffect, useState } from "react";

interface ShareDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const socials = [
  { label: "微信", icon: "ri-wechat-fill", color: "bg-primary-100 text-primary-800" },
  { label: "微博", icon: "ri-weibo-fill", color: "bg-accent-100 text-accent-700" },
  { label: "QQ", icon: "ri-qq-fill", color: "bg-secondary-100 text-secondary-800" },
  { label: "邮件", icon: "ri-mail-fill", color: "bg-background-200 text-foreground-700" },
];

export default function ShareDialog({ open, onClose, title }: ShareDialogProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) setCopied(false);
  }, [open]);

  if (!open) return null;

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = document.createElement("input");
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-primary-950/70" onClick={onClose}></div>
      <div className="relative w-full max-w-md rounded-lg bg-background-50 p-6 animate-fade-up">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-heading font-bold text-foreground-950">分享「{title}」</h3>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="mt-4 flex items-center gap-2 rounded-md bg-background-100 border border-background-200 px-3 py-2">
          <i className="ri-link text-foreground-400"></i>
          <span className="flex-1 text-xs text-foreground-600 truncate">{window.location.href}</span>
          <button
            type="button"
            onClick={copyLink}
            className="px-3 py-1.5 rounded-md bg-accent-500 text-primary-950 text-xs font-label font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            {copied ? "已复制" : "复制链接"}
          </button>
        </div>

        <div className="mt-5">
          <p className="text-xs text-foreground-500 mb-3">分享到社交平台</p>
          <div className="grid grid-cols-4 gap-3">
            {socials.map((s) => (
              <div
                key={s.label}
                className="flex flex-col items-center gap-1.5 py-2 rounded-md hover:bg-background-100 transition-colors"
              >
                <span className={`w-11 h-11 rounded-full flex items-center justify-center ${s.color}`}>
                  <i className={`${s.icon} text-xl`}></i>
                </span>
                <span className="text-[11px] text-foreground-600">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}